import { spacing } from 'ams-common';
import styled from 'styled-components';

export const StyledButtonWrapper = styled.div`
  margin-top: ${spacing.sm};
`;
